<template>
  <div
    v-if="newUser || userExists"
    class="lg:absolute lg:-bottom-24 lg:-right-72"
  >
    <div class="modal-box bg-blue-100">
      <p class="text-lg font-semibold leading-snug text-blue-800">
        <slot name="msg"> </slot>
      </p>
      <div class="modal-action">
        <button @click="closeModal" class="btn btn-info">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Alert Modal",
  props: ["newUser", "closeModal", "userExists", "errorModal"],
};
</script>
